export const promohub = {

  agegate: {
    title: '¡Bienvenid@!'
  },
  signup: {
    description: 'Ahora eres parte del equipo. Revisa tus correos para comenzar a registrar códigos, ganar XP COINS y escalar en el ranking para ganar un VIAJE AL MUNDIAL 2022 en Qatar o alguno de los kits mundialistas para que uses en los partidos con tus amigos.'
  },

}